import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { useEffect, useState } from 'react'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { INITIAL_CONJUNCTION_FILTER, PAGE_CONFIG } from '../../../../configs'
import { getDecoratedFetchFn } from '../../../../helpers/getDecoratedFetchFn'
import { IContactTab } from '../../../../models'

interface IUseNewContactSource extends Partial<IContactTab> {}

export function useNewContactSource({
  partnerId = '',
  onAfterFetch,
  onBeforeFetch,
  onCatchError,
}: IUseNewContactSource) {
  const [source, setSource] = useState<Crud>()

  useEffect(() => {
    const crud = CrudStore.get(
      CrudStoreItem.ContactExtData,
      `partnerContacts-newContactList-${partnerId}`
    )
    // const originalFetchFn = crud.fetch.bind(crud)

    // crud.fetch = getDecoratedFetchFn({
    //   context: crud,
    //   originalFetchFn,
    //   onAfterFetch,
    //   onBeforeFetch,
    //   onCatchError,
    // })

    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerID',
          operator: Operator.EQUAL,
          value: partnerId,
        },
        {
          field: 'ContactID',
          operator: Operator.STARTSWITH,
          value: 'new-',
        },
        {
          field: 'WorkflowStatus',
          operator: Operator.NOTEQUAL,
          value: 'Done',
        },
      ],
    })

    crud.setFilter(INITIAL_CONJUNCTION_FILTER)

    crud.setSort([
      {
        dir: 'desc',
        field: 'IsKeyContact',
      },
      {
        field: 'LastName',
        dir: 'asc',
      },
    ])

    crud.setPaging(PAGE_CONFIG)

    setSource(crud)
  }, [onAfterFetch, onBeforeFetch, onCatchError, partnerId])

  return { source }
}
